/**
 * Social login feature flag
 * Set to true to enable social auth buttons (Google, Facebook, Apple)
 * Must be coordinated with Django SOCIAL_LOGIN_ENABLED setting
 */
export const SOCIAL_LOGIN_ENABLED = true;

/**
 * mojeID login feature flag — set to true once MOJEID_CLIENT_ID + MOJEID_CLIENT_SECRET
 * env vars are configured on the server and the app is registered with CZ.NIC.
 */
export const MOJEID_ENABLED = false;
